// extracted by mini-css-extract-plugin
export default {"scoreContainer":"EntityScoreButton_scoreContainer__6zTCK","scoreLabel":"EntityScoreButton_scoreLabel__ntKXe","scoreButton":"EntityScoreButton_scoreButton__fvXEd"};